import { render, staticRenderFns } from "./taskForm.vue?vue&type=template&id=d9626b4c&scoped=true"
import script from "./taskForm.vue?vue&type=script&lang=js"
export * from "./taskForm.vue?vue&type=script&lang=js"
import style0 from "./taskForm.vue?vue&type=style&index=0&id=d9626b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9626b4c",
  null
  
)

export default component.exports